import { AxiosResponse } from "axios"
import { axiosInstance, MessageResponse } from "./common"

export interface FMR1ReportRequest {
    case_id: string
}

export interface SCNReportRequest extends FMR1ReportRequest {}

export interface GetSCNParams {
    /** Optional report ID - when not provided, returns all SCN reports for the case */
    report_id?: string
}

export interface GetSCNResponseParams extends GetSCNParams {}

export enum ReportStatus{
    SUBMITTED = "SUBMITTED",
    IN_PROGRESS = "IN_PROGRESS",
    AVAILABLE = "AVAILABLE",
    FAILED = "FAILED",
}

export interface SCNReport {
    report_id: string;
    party_id: string;
    content?: string;
    status: ReportStatus;
    last_updated_at: string;
}

export interface SCNReportsResponse {
    scn_reports: SCNReport[]
}

export interface UpdateSCNRequest {
    party_id: string;
    content: string;
}


export interface SCNResponseReportsResponse {
    responses: SCNResponseReport[]
}

export interface SCNResponseReport {
    report_id: string;
    party_id: string;
    is_response_received: boolean;
    file_reference?: string;
    file_name?: string;
    last_updated_at: string;
}

export interface GenerateSCNRequest {
    party_id: string;
    report_id: string;
}

export interface GetROParams {
    report_id?: string;
}

export interface ROReport {
    report_id: string;
    party_id: string;
    content?: string;
    status: ReportStatus;
    last_updated_at: string;
}

export interface ReasonedOrdersResponse {
    ro_reports: ROReport[];
}

export interface GenerateRORequest {
    party_id: string;
    report_id: string;
}

export interface UpsertRORequest {
    party_id: string;
    content: string;
}

export interface UpsertFICReportRequest {
    review_committee_remarks: string;
    fraud_classification: string;
}

export interface FICReportResponse {
    review_committee_remarks: string;
    fraud_classification: string;
    status: ReportStatus;
    last_updated_at: string;
}

export interface BoardPresentationResponse {
    case_overview: string;
    modus_operandi: string;
    investigation_summary: string;
    actions_and_recommendations: string;
    status: ReportStatus;
    last_updated_at: string;
}

export interface UpsertBoardPresentationRequest {
    case_overview: string;
    modus_operandi: string;
    investigation_summary: string;
    actions_and_recommendations: string;
}

const ReportsAPI = {
      get_fic: async ({ case_id }: { case_id: string }) => {
        const response: AxiosResponse<FICReportResponse> = await axiosInstance.get(
            `v1/cases/${case_id}/reports/fraud-classification`
        );
        return response.data;
    },
    
    update_fic: async (case_id: string, request: UpsertFICReportRequest): Promise<MessageResponse> => {
        const response: AxiosResponse<MessageResponse> = await axiosInstance.put(
            `v1/cases/${case_id}/reports/fraud-classification`,
            request
        );
        return response.data;
    },
}

export default ReportsAPI;